import { render, staticRenderFns } from "./ModalProfileLogin.vue?vue&type=template&id=080c6f96&"
import script from "./ModalProfileLogin.vue?vue&type=script&lang=js&"
export * from "./ModalProfileLogin.vue?vue&type=script&lang=js&"
import style0 from "./ModalProfileLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports